<!-- ============ LIST VIEW ============ -->
<div class="returns-container" *ngIf="view === 'list'">

  <div class="toolbar">
    <div class="counters">
      <div class="counter"><span class="num">{{ unpaidCount }}</span><span class="lbl">Returns Unpaid</span></div>
      <div class="counter"><span class="num">{{ partiallyPaidCount }}</span><span class="lbl">Partially Paid</span></div>
      <div class="counter"><span class="num">{{ dueCount }}</span><span class="lbl">Returns Due</span></div>
    </div>

    <div class="filters">
      <mat-form-field appearance="outline" class="f">
        <mat-label>Year</mat-label>
        <mat-select [(ngModel)]="selectedYear" (ngModelChange)="applyFilters()">
          <mat-option value="all">All</mat-option>
          <mat-option *ngFor="let y of years" [value]="y">{{ y }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="f">
        <mat-label>Return type</mat-label>
        <mat-select [(ngModel)]="selectedType" (ngModelChange)="applyFilters()">
          <mat-option value="all">All</mat-option>
          <mat-option *ngFor="let t of types" [value]="t">{{ t | titlecase }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="f">
        <mat-label>Status</mat-label>
        <mat-select [(ngModel)]="selectedStatus" (ngModelChange)="applyFilters()">
          <mat-option value="all">All</mat-option>
          <mat-option *ngFor="let s of statuses" [value]="s">{{ s.replace('_',' ') | titlecase }}</mat-option>
        </mat-select>
      </mat-form-field>

      <button mat-stroked-button color="primary" class="new-btn" (click)="onNewReturn()">
        <mat-icon>add</mat-icon> NEW RETURN
      </button>
    </div>
  </div>

  <div class="table-card mat-elevation-z1">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="period">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Period</th>
        <td mat-cell *matCellDef="let r">{{ r.period }}</td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Return type</th>
        <td mat-cell *matCellDef="let r">
          <span class="tag tag-{{ baseType(r) | lowercase }}">{{ typeLabel(r) }}</span>
          <span class="tag tag-secondary" *ngIf="secondaryTag(r)">{{ secondaryTag(r) }}</span>
          <span class="tag tag-shared" *ngIf="r.shared">Shared from {{ r.owningAccountName }}</span>
          <div class="reported-by" *ngIf="r.reportedByRole">Reported by {{ r.reportedByRole === 'MANAGEMENT_COMPANY' ? 'Management Co' : 'Owner' }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="dueDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Due date</th>
        <td mat-cell *matCellDef="let r">{{ r.dueDate | date }}</td>
      </ng-container>

      <ng-container matColumnDef="properties">
        <th mat-header-cell *matHeaderCellDef>Properties</th>
        <td mat-cell *matCellDef="let r">{{ propertiesLabel(r) }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let r">
          <span class="status-chip {{ statusClass(r.status) }}">{{ r.status.replace('_',' ') | titlecase }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="totalAmountDue">
        <th mat-header-cell *matHeaderCellDef class="right">Total amount due</th>
        <td mat-cell *matCellDef="let r" class="right">{{ r.totalAmountDue | currency }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let r; columns: displayedColumns;" class="clickable" (click)="onRow(r)"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell empty" [attr.colspan]="displayedColumns.length">
          {{ loading ? 'Loading…' : 'No returns found.' }}
        </td>
      </tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 50]" [pageSize]="10" showFirstLastButtons></mat-paginator>
  </div>
</div>

<!-- ============ DETAIL (full-page editor, Search path — not a modal) ============ -->
<div class="detail-container" *ngIf="view === 'detail' && selectedReturnId">
  <div class="create-head">
    <button mat-button class="back-link" (click)="backToList()">
      <mat-icon>arrow_back</mat-icon> Back to returns
    </button>
  </div>
  <div class="info-note" *ngIf="detailReadOnly">
    <mat-icon>lock</mat-icon>
    {{ detailPlanLabel || 'This return is part of a plan' }} — it is read-only and can only be paid through its plan return.
  </div>
  <app-return-detail
    [embedded]="true"
    [embeddedReturnId]="selectedReturnId"
    [embeddedCustomerId]="account.id"
    [embeddedEdit]="detailEdit"
    [embeddedReadOnly]="detailReadOnly"
    (back)="onDetailBack($event)">
  </app-return-detail>
</div>

<!-- ============ PLAN DETAIL (installment / assessment / lien return) ============ -->
<div class="create-container" *ngIf="view === 'plan' && planReturn">
  <div class="create-head">
    <button mat-button class="back-link" (click)="backToList()">
      <mat-icon>arrow_back</mat-icon> Back to returns
    </button>
    <span class="create-title">
      <mat-icon>account_tree</mat-icon>
      {{ typeLabel(planReturn) }} — {{ planReturn.period }}
    </span>
  </div>

  <div class="form-card mat-elevation-z1">
    <div class="periods-head">
      <span>Summary</span>
      <span class="status-chip {{ statusClass(planReturn.status) }}">{{ planReturn.status.replace('_',' ') | titlecase }}</span>
    </div>
    <div class="selected-total">
      Due date: <strong>{{ planReturn.dueDate | date }}</strong>
      &nbsp;|&nbsp; Amount due: <strong>{{ planReturn.totalAmountDue | currency }}</strong>
      &nbsp;|&nbsp; Balance: <strong>{{ planReturn.balanceDue | currency }}</strong>
    </div>
    <div class="selected-total" *ngIf="planDetail">
      Plan #{{ planDetail.planId }} ({{ planDetail.status }}) —
      paid {{ planDetail.totalPaid | currency }} of {{ planDetail.totalAmount | currency }}
    </div>
  </div>

  <div class="form-card mat-elevation-z1" *ngIf="planDetail">
    <div class="periods-head"><span>Payment schedule</span></div>
    <table class="select-table">
      <tr class="sel-head"><th>#</th><th>Period</th><th>Due date</th><th>Status</th><th class="right">Amount</th></tr>
      <tr *ngFor="let s of planDetail.schedule" class="sel-row">
        <td>{{ s.sequenceNo === 0 ? 'Down' : s.sequenceNo }}</td>
        <td>{{ s.period }}</td>
        <td>{{ s.dueDate | date }}</td>
        <td>{{ s.status | titlecase }}</td>
        <td class="right">{{ s.amount | currency }}</td>
      </tr>
    </table>
  </div>

  <div class="form-card mat-elevation-z1">
    <div class="periods-head"><span>Returns included</span></div>
    <table class="select-table">
      <tr class="sel-head"><th>Period</th><th>Type</th><th>Due date</th><th>Status</th><th class="right">Balance due</th></tr>
      <tr *ngFor="let u of planUnderlying" class="sel-row clickable" (click)="openPlanUnderlying(u)">
        <td>{{ u.period }}</td>
        <td>{{ typeLabel(u) }}</td>
        <td>{{ u.dueDate | date }}</td>
        <td>{{ u.status.replace('_',' ') | titlecase }}</td>
        <td class="right">{{ u.balanceDue | currency }}</td>
      </tr>
      <tr *ngIf="planUnderlying.length === 0"><td colspan="5" class="empty">No linked returns found.</td></tr>
    </table>
  </div>

  <div class="footer-actions">
    <button mat-stroked-button (click)="openPlanReturnDetail()"><mat-icon>visibility</mat-icon> VIEW RETURN</button>
    <button mat-stroked-button color="warn" [disabled]="saving || (planReturn.amountPaid || 0) > 0" (click)="cancelPlan()">
      <mat-icon>delete_outline</mat-icon> {{ saving ? 'CANCELLING…' : 'CANCEL ' + typeLabel(planReturn).toUpperCase() }}
    </button>
  </div>
</div>

<!-- ============ CREATE: TYPE SELECT ============ -->
<div class="create-container" *ngIf="view === 'type'">
  <div class="create-head">
    <button mat-button (click)="backToList()"><mat-icon>arrow_back</mat-icon> Create a new return</button>
  </div>

  <div class="info-note">
    <mat-icon>info_outline</mat-icon>
    <span>Return lifecycle: regular &rarr; delinquent &rarr; installment &rarr; assessment &rarr; lien.</span>
  </div>

  <div class="type-cards">
    <div
      *ngFor="let card of createTypeCards"
      class="type-card"
      [class.selected]="selectedCreateType === card.key"
      [class.disabled]="!card.enabled"
      (click)="selectCreateType(card)"
    >
      <div class="type-card-head">
        <span class="type-title">{{ card.title }}
          <mat-icon class="type-info" matTooltipPosition="above" [matTooltip]="card.description">info_outline</mat-icon>
        </span>
        <mat-icon *ngIf="selectedCreateType === card.key && card.enabled">radio_button_checked</mat-icon>
        <mat-icon *ngIf="selectedCreateType !== card.key && card.enabled">radio_button_unchecked</mat-icon>
        <span class="soon" *ngIf="!card.enabled">Coming soon</span>
      </div>
      <p class="type-desc">{{ card.description }}</p>
    </div>
  </div>

  <div class="footer-actions center">
    <button mat-stroked-button color="warn" (click)="backToList()"><mat-icon>close</mat-icon> CANCEL</button>
    <button mat-flat-button color="primary" (click)="onTypeNext()"><mat-icon>arrow_forward</mat-icon> NEXT</button>
  </div>
</div>

<!-- ============ CREATE: REGULAR FORM ============ -->
<div class="create-container" *ngIf="view === 'regular'">
  <div class="create-head">
    <span class="create-title"><mat-icon>edit</mat-icon> Create a regular return</span>
  </div>

  <form [formGroup]="regularForm" class="regular-grid">
    <div class="form-card mat-elevation-z1">
      <div class="row">
        <mat-form-field appearance="outline" class="f">
          <mat-label>Month</mat-label>
          <mat-select formControlName="month">
            <mat-option *ngFor="let m of months" [value]="m.value">{{ m.label }}</mat-option>
          </mat-select>
          <mat-error *ngIf="regularForm.get('month')?.hasError('required')">Required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="f">
          <mat-label>Year</mat-label>
          <mat-select formControlName="year">
            <mat-option *ngFor="let y of years" [value]="y">{{ y }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="f">
          <mat-label>Frequency</mat-label>
          <mat-select formControlName="frequency">
            <mat-option *ngFor="let fr of frequencies" [value]="fr.value">{{ fr.label }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="info-note">
        <mat-icon>info</mat-icon>
        Active rental properties for this account are attached automatically when the return is created.
      </div>
    </div>

    <div class="settings-card mat-elevation-z1">
      <div class="settings-title"><mat-icon>settings</mat-icon> Settings</div>
      <mat-slide-toggle formControlName="enableCustomerEditing">Enable customer editing</mat-slide-toggle>
      <p class="settings-hint">Fees / Allowances, Notes, Attachments and History become available once the return is created.</p>
    </div>
  </form>

  <div class="footer-actions">
    <button mat-stroked-button (click)="backToType()"><mat-icon>arrow_back</mat-icon> BACK</button>
    <button mat-stroked-button color="warn" (click)="backToList()"><mat-icon>close</mat-icon> CANCEL</button>
    <button mat-flat-button color="primary" [disabled]="saving" (click)="onCreateRegular()">
      <mat-icon>edit</mat-icon> {{ saving ? 'CREATING…' : 'CREATE RETURN' }}
    </button>
  </div>
</div>

<!-- ============ CREATE: ASSESSMENT ============ -->
<div class="create-container" *ngIf="view === 'assessment'">
  <div class="create-head">
    <span class="create-title"><mat-icon>gavel</mat-icon> Open an assessment</span>
  </div>

  <!-- Mode: roll existing returns into one lump-sum, or estimate unreported periods (SWAG) -->
  <div class="type-cards">
    <div class="type-card" [class.selected]="assessmentMode === 'rollup'" (click)="setAssessmentMode('rollup')">
      <div class="type-card-head">
        <span class="type-title">ROLL UP EXISTING RETURNS</span>
        <mat-icon>{{ assessmentMode === 'rollup' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
      </div>
      <p class="type-desc">Select delinquent returns and roll them into ONE lump-sum assessment return with a single due date. Fees and interest are computed automatically.</p>
    </div>
    <div class="type-card" [class.selected]="assessmentMode === 'swag'" (click)="setAssessmentMode('swag')">
      <div class="type-card-head">
        <span class="type-title">ESTIMATED PERIODS</span>
        <mat-icon>{{ assessmentMode === 'swag' ? 'radio_button_checked' : 'radio_button_unchecked' }}</mat-icon>
      </div>
      <p class="type-desc">The owner never filed: estimate occupancy per period and create per-period additional-tax returns.</p>
    </div>
  </div>

  <!-- ===== Roll-up mode ===== -->
  <ng-container *ngIf="assessmentMode === 'rollup'">
    <div class="form-card mat-elevation-z1">
      <div class="periods-head"><span>Select outstanding returns to assess</span></div>
      <table class="select-table">
        <tr class="sel-head"><th></th><th>Period</th><th>Type</th><th>Due date</th><th class="right">Balance due</th></tr>
        <tr *ngFor="let r of eligibleReturns" class="sel-row">
          <td><mat-checkbox [checked]="isSelected(r)"
                            [matTooltip]="isUnfiled(r) ? 'Nothing filed: will be submitted as a $0 zero return (no rent) and left out' : ''"
                            (change)="toggleSelect(r, $event.checked)"></mat-checkbox></td>
          <td>{{ r.period }}<span class="sel-hint" *ngIf="isUnfiled(r)">Will be filed as $0 zero return</span></td>
          <td>{{ typeLabel(r) }}</td>
          <td>{{ r.dueDate | date }}</td>
          <td class="right">{{ (r.balanceDue ?? r.totalAmountDue) | currency }}</td>
        </tr>
        <tr *ngIf="eligibleReturns.length === 0"><td colspan="5" class="empty">No eligible outstanding returns.</td></tr>
      </table>
      <div class="selected-total">
        Selected total: <strong>{{ selectedTotal | currency }}</strong> ({{ selectedReturnIds.size }} return(s))
      </div>
    </div>

    <form [formGroup]="rollupForm" class="form-card mat-elevation-z1">
      <div class="row">
        <mat-form-field appearance="outline" class="f">
          <mat-label>Cause</mat-label>
          <mat-select formControlName="cause">
            <mat-option *ngFor="let c of rollupCauses" [value]="c.value">{{ c.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="f">
          <mat-label>Due date</mat-label>
          <input matInput [matDatepicker]="dpDue" formControlName="dueDate" />
          <mat-datepicker-toggle matIconSuffix [for]="dpDue"></mat-datepicker-toggle>
          <mat-datepicker #dpDue></mat-datepicker>
          <mat-error *ngIf="rollupForm.get('dueDate')?.hasError('required')">Required</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="f">
          <mat-label>Calculation date (default today)</mat-label>
          <input matInput [matDatepicker]="dpCalc" formControlName="calculationDate" />
          <mat-datepicker-toggle matIconSuffix [for]="dpCalc"></mat-datepicker-toggle>
          <mat-datepicker #dpCalc></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="f">
          <mat-label>Audit reference</mat-label>
          <input matInput formControlName="auditReference" autocomplete="off" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="f">
          <mat-label>Statute basis</mat-label>
          <input matInput formControlName="statuteBasis" autocomplete="off" />
        </mat-form-field>
      </div>
    </form>

    <div class="form-card mat-elevation-z1" *ngIf="preview">
      <div class="periods-head"><span>Amounts included</span></div>
      <table class="select-table">
        <tr class="sel-head">
          <th>Period</th><th class="right">Tax</th><th class="right">Penalty</th>
          <th class="right">Interest</th><th class="right">Balance</th>
        </tr>
        <tr *ngFor="let row of preview.returns" class="sel-row">
          <td>{{ row.period }}</td>
          <td class="right">{{ row.tax | currency }}</td>
          <td class="right override-cell">
            <span class="computed">{{ row.penalty | currency }}</span>
            <input type="number" min="0" placeholder="Override"
                   [(ngModel)]="overrideEdits[row.returnId].penalty"
                   (change)="onOverrideChanged()" />
          </td>
          <td class="right override-cell">
            <span class="computed">{{ row.interest | currency }}</span>
            <input type="number" min="0" placeholder="Override"
                   [(ngModel)]="overrideEdits[row.returnId].interest"
                   (change)="onOverrideChanged()" />
          </td>
          <td class="right">{{ row.balance | currency }}</td>
        </tr>
      </table>
      <div class="selected-total">
        Assessment total: <strong>{{ preview.total | currency }}</strong>
        (tax {{ preview.totalTax | currency }}, penalty {{ preview.totalPenalty | currency }},
        interest {{ preview.totalInterest | currency }})
      </div>
      <div class="info-note" *ngIf="preview.pendingRateReturnIds.length">
        <mat-icon>warning</mat-icon>
        An interest rate is not posted yet for {{ preview.pendingRateReturnIds.length }} period(s).
      </div>
    </div>

    <div class="footer-actions">
      <button mat-stroked-button (click)="backToType()"><mat-icon>arrow_back</mat-icon> BACK</button>
      <button mat-stroked-button color="warn" (click)="backToList()"><mat-icon>close</mat-icon> CANCEL</button>
      <button mat-stroked-button color="primary" [disabled]="saving" (click)="onPreviewRollup()">
        <mat-icon>calculate</mat-icon> {{ preview ? 'RECALCULATE' : 'PREVIEW' }}
      </button>
      <button mat-flat-button color="primary"
              [disabled]="saving || !preview || preview.pendingRateReturnIds.length > 0"
              (click)="onCreateRollup()">
        <mat-icon>gavel</mat-icon> {{ saving ? 'WORKING…' : 'CREATE ASSESSMENT' }}
      </button>
    </div>
  </ng-container>

  <!-- ===== SWAG mode (estimated periods) ===== -->
  <form [formGroup]="assessmentForm" class="assessment-form" *ngIf="assessmentMode === 'swag'">
    <div class="form-card mat-elevation-z1">
      <div class="row">
        <mat-form-field appearance="outline" class="f">
          <mat-label>Cause</mat-label>
          <mat-select formControlName="cause">
            <mat-option *ngFor="let c of causes" [value]="c.value">{{ c.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="f">
          <mat-label>Audit reference</mat-label>
          <input matInput formControlName="auditReference" autocomplete="off" />
        </mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="field-full">
        <mat-label>Statute basis</mat-label>
        <input matInput formControlName="statuteBasis" autocomplete="off" />
      </mat-form-field>

      <div class="sol-row">
        <mat-slide-toggle formControlName="overrideSol">Assess outside statute of limitations</mat-slide-toggle>
      </div>
      <mat-form-field appearance="outline" class="field-full" *ngIf="assessmentForm.get('overrideSol')?.value">
        <mat-label>Override justification</mat-label>
        <textarea matInput rows="2" formControlName="justification"></textarea>
      </mat-form-field>
    </div>

    <div class="form-card mat-elevation-z1" formArrayName="periods">
      <div class="periods-head">
        <span>Reassessed periods</span>
        <button mat-stroked-button color="primary" type="button" (click)="addPeriod()">
          <mat-icon>add</mat-icon> ADD PERIOD
        </button>
      </div>

      <div class="period-row" *ngFor="let p of periods.controls; let i = index" [formGroupName]="i">
        <mat-form-field appearance="outline" class="p-month">
          <mat-label>Month</mat-label>
          <mat-select formControlName="month">
            <mat-option *ngFor="let m of months" [value]="m.value">{{ m.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="p-year">
          <mat-label>Year</mat-label>
          <mat-select formControlName="year">
            <mat-option *ngFor="let y of years" [value]="y">{{ y }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="p-amt">
          <mat-label>Additional tax</mat-label>
          <input matInput type="number" formControlName="additionalTax" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="p-amt">
          <mat-label>Penalty</mat-label>
          <input matInput type="number" formControlName="penalty" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="p-amt">
          <mat-label>Interest</mat-label>
          <input matInput type="number" formControlName="interest" />
        </mat-form-field>
        <button mat-icon-button color="warn" type="button" (click)="removePeriod(i)" [disabled]="periods.length === 1">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
    </div>
  </form>

  <div class="footer-actions" *ngIf="assessmentMode === 'swag'">
    <button mat-stroked-button (click)="backToType()"><mat-icon>arrow_back</mat-icon> BACK</button>
    <button mat-stroked-button color="warn" (click)="backToList()"><mat-icon>close</mat-icon> CANCEL</button>
    <button mat-flat-button color="primary" [disabled]="saving" (click)="onCreateAssessment()">
      <mat-icon>gavel</mat-icon> {{ saving ? 'CREATING…' : 'CREATE ASSESSMENT' }}
    </button>
  </div>
</div>

<!-- ============ CREATE: INSTALLMENT ============ -->
<div class="create-container" *ngIf="view === 'installment'">
  <div class="create-head">
    <span class="create-title"><mat-icon>event_repeat</mat-icon> New installment plan</span>
  </div>

  <div class="form-card mat-elevation-z1">
    <div class="periods-head"><span>Select outstanding returns to include</span></div>

    <table class="select-table">
      <tr class="sel-head">
        <th><mat-checkbox [checked]="allSelected"
                          [indeterminate]="selectedReturnIds.size > 0 && !allSelected"
                          [disabled]="saving || eligibleReturns.length === 0"
                          matTooltip="Select all" (change)="toggleAll($event.checked)"></mat-checkbox></th>
        <th>Period</th><th>Type</th><th>Due date</th><th class="right">Balance due</th>
      </tr>
      <tr *ngFor="let r of eligibleReturns" class="sel-row">
        <td><mat-checkbox [checked]="isSelected(r)" [disabled]="saving"
                          [matTooltip]="isUnfiled(r) ? 'Nothing filed: will be submitted as a $0 zero return (no rent) and left out' : ''"
                          (change)="toggleSelect(r, $event.checked)"></mat-checkbox></td>
        <td>{{ r.period }}<span class="sel-hint" *ngIf="isUnfiled(r)">Will be filed as $0 zero return</span></td>
        <td>{{ typeLabel(r) }}</td>
        <td>{{ r.dueDate | date }}</td>
        <td class="right">{{ (r.balanceDue ?? r.totalAmountDue) | currency }}</td>
      </tr>
      <tr *ngIf="eligibleReturns.length === 0">
        <td colspan="5" class="empty">No eligible outstanding returns.</td>
      </tr>
    </table>

    <div class="selected-total">
      Selected total: <strong>{{ selectedTotal | currency }}</strong> ({{ selectedReturnIds.size }} return(s))
    </div>
  </div>

  <form [formGroup]="installmentForm" class="form-card mat-elevation-z1">
    <div class="row">
      <mat-form-field appearance="outline" class="f">
        <mat-label>Down payment</mat-label>
        <input matInput type="number" formControlName="downPaymentAmount" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="f">
        <mat-label>Number of installments</mat-label>
        <input matInput type="number" formControlName="installmentCount" min="1" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="f">
        <mat-label>First payment due date</mat-label>
        <input matInput [matDatepicker]="dpFirst" formControlName="firstDueDate" />
        <mat-datepicker-toggle matIconSuffix [for]="dpFirst"></mat-datepicker-toggle>
        <mat-datepicker #dpFirst></mat-datepicker>
        <mat-error *ngIf="installmentForm.get('firstDueDate')?.hasError('required')">Required</mat-error>
      </mat-form-field>
    </div>
  </form>

  <!-- Preview: per-return breakdown (editable penalty/interest) + generated schedule -->
  <div class="form-card mat-elevation-z1" *ngIf="preview">
    <div class="periods-head"><span>Amounts included (as of today)</span></div>
    <table class="select-table">
      <tr class="sel-head">
        <th>Period</th><th class="right">Tax</th><th class="right">Penalty</th>
        <th class="right">Interest</th><th class="right">Balance</th>
      </tr>
      <tr *ngFor="let row of preview.returns" class="sel-row">
        <td>{{ row.period }}</td>
        <td class="right">{{ row.tax | currency }}</td>
        <td class="right override-cell">
          <span class="computed">{{ row.penalty | currency }}</span>
          <input type="number" min="0" placeholder="Override"
                 [(ngModel)]="overrideEdits[row.returnId].penalty"
                 (change)="onOverrideChanged()" />
        </td>
        <td class="right override-cell">
          <span class="computed">{{ row.interest | currency }}</span>
          <input type="number" min="0" placeholder="Override"
                 [(ngModel)]="overrideEdits[row.returnId].interest"
                 (change)="onOverrideChanged()" />
        </td>
        <td class="right">{{ row.balance | currency }}</td>
      </tr>
    </table>
    <div class="selected-total">
      Tax {{ preview.totalTax | currency }} + penalty {{ preview.totalPenalty | currency }}
      + interest {{ preview.totalInterest | currency }} =
      <strong>{{ preview.total | currency }}</strong>
    </div>
    <div class="info-note" *ngIf="preview.pendingRateReturnIds.length">
      <mat-icon>warning</mat-icon>
      An interest rate is not posted yet for {{ preview.pendingRateReturnIds.length }} period(s); the plan cannot be created until it is.
    </div>
    <div class="info-note">
      <mat-icon>info</mat-icon>
      Adjust penalty/interest above ("honest mistake" relief). Any override freezes further accrual on that return.
    </div>

    <div class="periods-head"><span>Payment schedule</span></div>
    <table class="select-table">
      <tr class="sel-head"><th>#</th><th>Period</th><th>Due date</th><th class="right">Amount</th></tr>
      <tr *ngFor="let s of preview.schedule" class="sel-row">
        <td>{{ s.sequenceNo === 0 ? 'Down' : s.sequenceNo }}</td><td>{{ s.period }}</td><td>{{ s.dueDate | date }}</td>
        <td class="right">{{ s.amount | currency }}</td>
      </tr>
    </table>
  </div>

  <div class="footer-actions">
    <button mat-stroked-button (click)="backToType()"><mat-icon>arrow_back</mat-icon> BACK</button>
    <button mat-stroked-button color="warn" (click)="backToList()"><mat-icon>close</mat-icon> CANCEL</button>
    <button mat-stroked-button color="primary" [disabled]="saving" (click)="onPreviewInstallment()">
      <mat-icon>calculate</mat-icon> {{ preview ? 'RECALCULATE' : 'PREVIEW' }}
    </button>
    <button mat-flat-button color="primary" [disabled]="saving || !preview || preview.pendingRateReturnIds.length > 0"
            (click)="onCreateInstallment()">
      <mat-icon>event_repeat</mat-icon> {{ saving ? 'WORKING…' : 'CREATE PLAN' }}
    </button>
  </div>
</div>

<!-- ============ CREATE: LIEN ============ -->
<div class="create-container" *ngIf="view === 'lien'">
  <div class="create-head">
    <span class="create-title"><mat-icon>account_balance</mat-icon> Record a lien</span>
  </div>

  <div class="info-note warn">
    <mat-icon>warning</mat-icon>
    Verify the debt is delinquent and that all required notices and due process have been provided.
  </div>

  <div class="form-card mat-elevation-z1">
    <div class="periods-head"><span>Select delinquent returns to lien</span></div>
    <table class="select-table">
      <tr class="sel-head"><th></th><th>Period</th><th>Status</th><th>Due date</th><th class="right">Balance due</th></tr>
      <tr *ngFor="let r of delinquentReturns" class="sel-row">
        <td><mat-checkbox [checked]="isSelected(r)"
                          [matTooltip]="isUnfiled(r) ? 'Nothing filed: will be submitted as a $0 zero return (no rent) and left out' : ''"
                          (change)="toggleSelect(r, $event.checked)"></mat-checkbox></td>
        <td>{{ r.period }}<span class="sel-hint" *ngIf="isUnfiled(r)">Will be filed as $0 zero return</span></td>
        <td>{{ r.status.replace('_',' ') | titlecase }}</td>
        <td>{{ r.dueDate | date }}</td>
        <td class="right">{{ (r.balanceDue ?? r.totalAmountDue) | currency }}</td>
      </tr>
      <tr *ngIf="delinquentReturns.length === 0"><td colspan="5" class="empty">No delinquent returns.</td></tr>
    </table>
    <div class="selected-total">Selected: <strong>{{ selectedReturnIds.size }}</strong> return(s)</div>
  </div>

  <form [formGroup]="lienForm" class="form-card mat-elevation-z1">
    <div class="row">
      <mat-form-field appearance="outline" class="f">
        <mat-label>Notice sent</mat-label>
        <input matInput [matDatepicker]="dp1" formControlName="noticeSentDate" />
        <mat-datepicker-toggle matIconSuffix [for]="dp1"></mat-datepicker-toggle>
        <mat-datepicker #dp1></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="f">
        <mat-label>Demand issued</mat-label>
        <input matInput [matDatepicker]="dp2" formControlName="demandIssuedDate" />
        <mat-datepicker-toggle matIconSuffix [for]="dp2"></mat-datepicker-toggle>
        <mat-datepicker #dp2></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="f">
        <mat-label>Cure deadline</mat-label>
        <input matInput [matDatepicker]="dp3" formControlName="cureDeadline" />
        <mat-datepicker-toggle matIconSuffix [for]="dp3"></mat-datepicker-toggle>
        <mat-datepicker #dp3></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline" class="f">
        <mat-label>Statute basis</mat-label>
        <input matInput formControlName="statuteBasis" autocomplete="off" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="f">
        <mat-label>Lien recorded reference</mat-label>
        <input matInput formControlName="lienRecordedReference" autocomplete="off" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="f">
        <mat-label>Filing fee (blank = $20 catalog fee)</mat-label>
        <input matInput type="number" formControlName="lienFeeAmount" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="f">
        <mat-label>Due date (blank = 30 days)</mat-label>
        <input matInput [matDatepicker]="dpLienDue" formControlName="dueDate" />
        <mat-datepicker-toggle matIconSuffix [for]="dpLienDue"></mat-datepicker-toggle>
        <mat-datepicker #dpLienDue></mat-datepicker>
      </mat-form-field>
    </div>
  </form>

  <div class="form-card mat-elevation-z1" *ngIf="preview">
    <div class="periods-head"><span>Lien amounts</span></div>
    <table class="select-table">
      <tr class="sel-head">
        <th>Period</th><th class="right">Tax</th><th class="right">Penalty</th>
        <th class="right">Interest</th><th class="right">Balance</th>
      </tr>
      <tr *ngFor="let row of preview.returns" class="sel-row">
        <td>{{ row.period }}</td>
        <td class="right">{{ row.tax | currency }}</td>
        <td class="right">{{ row.penalty | currency }}</td>
        <td class="right">{{ row.interest | currency }}</td>
        <td class="right">{{ row.balance | currency }}</td>
      </tr>
    </table>
    <div class="selected-total">
      Lien total (incl. clerk-of-court filing fee): <strong>{{ preview.total | currency }}</strong>
    </div>
  </div>

  <div class="footer-actions">
    <button mat-stroked-button (click)="backToType()"><mat-icon>arrow_back</mat-icon> BACK</button>
    <button mat-stroked-button color="warn" (click)="backToList()"><mat-icon>close</mat-icon> CANCEL</button>
    <button mat-stroked-button color="primary" [disabled]="saving" (click)="onPreviewLien()">
      <mat-icon>calculate</mat-icon> {{ preview ? 'RECALCULATE' : 'PREVIEW' }}
    </button>
    <button mat-flat-button color="primary" [disabled]="saving" (click)="onCreateLien()">
      <mat-icon>account_balance</mat-icon> {{ saving ? 'RECORDING…' : 'RECORD LIEN' }}
    </button>
  </div>
</div>
